
/*
  UXS — TRANSCRIPTION V3
  DAY2K / UNIDOS X EL SONIDO

  - URL de Supabase corregida
  - Sesión anónima
  - Transcripción automática después de VOICE 002
  - Transcripción editable
  - Confirmación privada
  - Mensajes de error identificables
  - Protección contra resultados de grabaciones anteriores

  No modifica el visualizador ni el vocoder.
*/

(function () {
  "use strict";

  // ==========================================
  // SUPABASE
  // ==========================================

  const SUPABASE_URL =
    "https://owwcdrqwfevwbkubrlff.supabase.co";

  const SUPABASE_PUBLISHABLE_KEY =
    "sb_publishable_xn5hzUtHdOZNJZ0eRZLr_g_3SmeqUS4";

  const FUNCTION_NAME = "uxs-transcribe";

  const MAX_FILE_BYTES = 8 * 1024 * 1024;

  function initialize() {
    const root = document.getElementById(
      "uxs-experience"
    );

    const recording = document.getElementById(
      "uxs-recording"
    );

    const results = document.getElementById(
      "uxs-results"
    );

    if (!root || !recording || !results) return;

    if (root.dataset.transcriptionReady === "v3") {
      return;
    }

    root.dataset.transcriptionReady = "v3";

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    // ==========================================
    // ESTILOS
    // ==========================================

    document.getElementById(
      "uxs-transcription-styles"
    )?.remove();

    const style = document.createElement("style");

    style.id = "uxs-transcription-styles";

    style.textContent = `
      #uxs-transcription-panel {
        display: none;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        width: min(90vw, 420px);
        margin: 18px auto 0;
        font-family: monospace;
        text-align: center;
      }

      #uxs-transcription-panel.uxs-visible {
        display: flex;
        animation: uxs-transcription-enter .6s ease both;
      }

      #uxs-transcription-panel .uxs-t-heading {
        color: white;
        font-size: 13px;
        letter-spacing: 2px;
        font-weight: 400;
        line-height: 1.7;
      }

      #uxs-transcription-panel .uxs-t-description {
        color: rgba(255,255,255,.52);
        font-size: 10px;
        line-height: 1.9;
        letter-spacing: .7px;
      }

      #uxs-t-text {
        box-sizing: border-box;
        display: block;
        width: 100%;
        min-height: 112px;
        padding: 15px;
        resize: vertical;

        background: rgba(255,255,255,.025);
        color: white;

        border: 1px solid rgba(255,255,255,.35);
        border-radius: 10px;

        font-family: monospace;
        font-size: 12px;
        line-height: 1.8;
        outline: none;
      }

      #uxs-t-text:focus {
        border-color: white;
      }

      #uxs-t-text:disabled {
        opacity: .55;
      }

      .uxs-t-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 10px;
        width: 100%;
        margin-top: 14px;
      }

      #uxs-transcription-panel button {
        appearance: none;
        border: 1px solid rgba(255,255,255,.4);
        border-radius: 999px;
        background: transparent;
        color: white;

        min-height: 43px;
        padding: 12px 20px;

        font-family: monospace;
        font-size: 10px;
        letter-spacing: 1.2px;

        cursor: pointer;

        transition:
          opacity .3s ease,
          background .3s ease,
          transform .4s ease;
      }

      #uxs-transcription-panel button:hover {
        background: rgba(255,255,255,.08);
        transform: translateY(-2px);
      }

      #uxs-transcription-panel button:disabled {
        opacity: .4;
        cursor: not-allowed;
        transform: none;
      }

      #uxs-t-feedback {
        min-height: 20px;
        max-width: 390px;
        color: rgba(255,255,255,.55);
        font-size: 10px;
        letter-spacing: .7px;
        line-height: 1.9;
        overflow-wrap: anywhere;
      }

      #uxs-t-confirmed {
        display: none;
        color: white;
        font-size: 11px;
        letter-spacing: 1.2px;
        line-height: 1.9;
      }

      #uxs-transcription-panel.uxs-confirmed
      .uxs-t-editor {
        display: none;
      }

      #uxs-transcription-panel.uxs-confirmed
      #uxs-t-confirmed {
        display: block;
      }

      @keyframes uxs-transcription-enter {
        from {
          opacity: 0;
          transform: translateY(10px);
        }

        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      @media (prefers-reduced-motion: reduce) {
        #uxs-transcription-panel.uxs-visible {
          animation: none;
        }
      }
    `;

    document.head.appendChild(style);

    // ==========================================
    // INTERFAZ
    // ==========================================

    document.getElementById(
      "uxs-transcription-panel"
    )?.remove();

    const panel = document.createElement("section");

    panel.id = "uxs-transcription-panel";

    panel.innerHTML = `
      <div class="uxs-t-heading">
        ESTO ES LO QUE ESCUCHÉ.
      </div>

      <div class="uxs-t-description">
        REVISA TUS PALABRAS ANTES DE CONTINUAR.
      </div>

      <div class="uxs-t-editor" style="width:100%">

        <textarea
          id="uxs-t-text"
          aria-label="Transcripción de tu voz"
          maxlength="4000"
          placeholder="TUS PALABRAS APARECERÁN AQUÍ..."
        ></textarea>

        <div class="uxs-t-actions">

          <button
            id="uxs-t-generate"
            type="button"
          >
            VOLVER A TRANSCRIBIR
          </button>

          <button
            id="uxs-t-confirm"
            type="button"
          >
            CONFIRMAR MIS PALABRAS
          </button>

        </div>
      </div>

      <div
        id="uxs-t-feedback"
        role="status"
        aria-live="polite"
      ></div>

      <div id="uxs-t-confirmed">
        TUS PALABRAS HAN SIDO CONFIRMADAS.
      </div>
    `;

    const audioUI = document.getElementById(
      "uxs-audio-interface"
    );

    if (audioUI) {
      audioUI.insertAdjacentElement(
        "afterend",
        panel
      );
    } else {
      recording.appendChild(panel);
    }

    const field = panel.querySelector("#uxs-t-text");
    const generate = panel.querySelector("#uxs-t-generate");
    const confirm = panel.querySelector("#uxs-t-confirm");
    const feedback = panel.querySelector("#uxs-t-feedback");

    let client = null;
    let generation = 0;
    let busy = false;
    let confirmedText = "";
    let activeAudioSource = "";

    // ==========================================
    // API PARA FUTURAS ETAPAS DE UXS
    // ==========================================

    window.UXSTranscription = {
      getConfirmedText() {
        return confirmedText;
      },

      getPath() {
        return window.UXSSession?.path || null;
      },

      getQuestion() {
        return window.UXSSession?.deepQuestion || null;
      }
    };

    // ==========================================
    // VALIDACIÓN DE CONFIGURACIÓN
    // ==========================================

    function normalizedURL() {
      const url = new URL(SUPABASE_URL.trim());

      if (
        url.protocol !== "https:" ||
        !/^[a-z0-9-]+\.supabase\.co$/i.test(
          url.hostname
        )
      ) {
        throw new Error("CONFIG_URL");
      }

      return url.origin;
    }

    function getClient() {
      if (typeof window.supabase?.createClient !== "function") {
        throw new Error("LIBRARY_MISSING");
      }

      if (
        !SUPABASE_PUBLISHABLE_KEY.trim()
          .startsWith("sb_publishable_")
      ) {
        throw new Error("CONFIG_KEY");
      }

      if (!client) {
        client = window.supabase.createClient(
          normalizedURL(),
          SUPABASE_PUBLISHABLE_KEY.trim(),
          {
            auth: {
              persistSession: true,
              autoRefreshToken: true,
              detectSessionInUrl: false
            }
          }
        );
      }

      return client;
    }

    // ==========================================
    // SESIÓN ANÓNIMA
    // ==========================================

    async function ensureSession(supa) {
      const current = await supa.auth.getSession();

      if (current.error) {
        throw new Error("SESSION_ERROR");
      }

      if (current.data.session?.access_token) {
        return current.data.session;
      }

      const signedIn = await supa.auth.signInAnonymously();

      if (
        signedIn.error ||
        !signedIn.data.session?.access_token
      ) {
        throw new Error(
          "ANONYMOUS_AUTH_FAILED: " +
          (signedIn.error?.message || "Unknown error")
        );
      }

      return signedIn.data.session;
    }

    // ==========================================
    // ARCHIVO DE AUDIO
    // ==========================================

    function fileNameFor(blob) {
      const type = blob.type.toLowerCase();

      if (type.includes("webm")) return "uxs.webm";
      if (type.includes("mp4")) return "uxs.mp4";
      if (type.includes("ogg")) return "uxs.ogg";
      if (type.includes("mpeg")) return "uxs.mp3";
      if (type.includes("wav")) return "uxs.wav";

      throw new Error("UNSUPPORTED_FORMAT");
    }

    function currentAudioSource() {
      return document.getElementById(
        "uxs-playback"
      )?.getAttribute("src") || "";
    }

    // ==========================================
    // MENSAJES DE ERROR
    // ==========================================

    function explainError(error) {
      const message = String(error?.message || error);

      console.error(
        "UXS Transcription V3:",
        message
      );

      if (message.includes("CONFIG_URL")) {
        return "LA URL DE SUPABASE NO ES VÁLIDA.";
      }

      if (message.includes("CONFIG_KEY")) {
        return "LA CLAVE PÚBLICA DE SUPABASE NO ES VÁLIDA.";
      }

      if (message.includes("LIBRARY_MISSING")) {
        return "NO SE CARGÓ LA LIBRERÍA DE SUPABASE.";
      }

      if (message.includes("ANONYMOUS_AUTH_FAILED")) {
        return "NO SE PUDO CREAR TU SESIÓN ANÓNIMA. " +
          "REVISA AUTHENTICATION EN SUPABASE.";
      }

      if (message.includes("UNSUPPORTED_FORMAT")) {
        return "EL FORMATO DE LA GRABACIÓN NO ES COMPATIBLE.";
      }

      if (message.includes("FILE_TOO_LARGE")) {
        return "LA GRABACIÓN SUPERA EL TAMAÑO PERMITIDO.";
      }

      if (message.includes("SERVER_401")) {
        return "SUPABASE RECHAZÓ LA AUTENTICACIÓN (401).";
      }

      if (message.includes("SERVER_403")) {
        return "SUPABASE RECHAZÓ EL ACCESO (403).";
      }

      if (message.includes("SERVER_502")) {
        return "EL SERVICIO DE TRANSCRIPCIÓN FALLÓ (502). " +
          "REVISA LA CLAVE Y FACTURACIÓN DE OPENAI.";
      }

      if (message.includes("SERVER_503")) {
        return "FALTA CONFIGURAR UN SECRETO EN SUPABASE (503).";
      }

      if (message.includes("SERVER_")) {
        return "SUPABASE DEVOLVIÓ UN ERROR: " + message;
      }

      return "NO FUE POSIBLE TRANSCRIBIR. " +
        "PUEDES CORREGIR O ESCRIBIR TUS PALABRAS.";
    }

    // ==========================================
    // MOSTRAR PANEL
    // ==========================================

    function updateVisibility() {
      const ready =
        root.classList.contains("uxs-audio-ready");

      panel.classList.toggle(
        "uxs-visible",
        ready
      );
    }

    function reset() {
      generation++;

      busy = false;
      confirmedText = "";
      activeAudioSource = "";

      field.value = "";
      field.disabled = false;

      feedback.textContent = "";

      panel.classList.remove("uxs-confirmed");

      generate.disabled = false;
      confirm.disabled = false;

      updateVisibility();
    }

    // ==========================================
    // TRANSCRIPCIÓN REAL
    // ==========================================

    async function transcribe() {
      if (busy || panel.classList.contains("uxs-confirmed")) {
        return;
      }

      const source = currentAudioSource();

      if (!source) {
        feedback.textContent =
          "NO SE ENCONTRÓ LA GRABACIÓN ORIGINAL.";
        return;
      }

      const myGeneration = generation;

      busy = true;
      activeAudioSource = source;

      generate.disabled = true;
      generate.textContent = "TRANSCRIBIENDO...";

      feedback.textContent =
        "ESCUCHANDO TUS PALABRAS...";

      try {
        const supa = getClient();

        await ensureSession(supa);

        if (myGeneration !== generation) return;

        const audioResponse = await fetch(source);

        if (!audioResponse.ok) {
          throw new Error("AUDIO_UNAVAILABLE");
        }

        const blob = await audioResponse.blob();

        if (!blob.size) {
          throw new Error("EMPTY_AUDIO");
        }

        if (blob.size > MAX_FILE_BYTES) {
          throw new Error("FILE_TOO_LARGE");
        }

        const filename = fileNameFor(blob);

        const form = new FormData();

        form.append(
          "file",
          blob,
          filename
        );

        console.log(
          "UXS: enviando audio a la función."
        );

        const response = await supa.functions.invoke(
          FUNCTION_NAME,
          {
            body: form
          }
        );

        if (myGeneration !== generation) return;

        if (response.error) {
          let status = "UNKNOWN";

          try {
            status =
              response.error.context?.status ||
              "UNKNOWN";
          } catch (ignored) {}

          throw new Error("SERVER_" + status);
        }

        if (typeof response.data?.text !== "string") {
          throw new Error("EMPTY_TRANSCRIPTION");
        }

        field.value = response.data.text.trim();

        if (!field.value) {
          feedback.textContent =
            "NO PUDE IDENTIFICAR PALABRAS. " +
            "PUEDES ESCRIBIRLAS MANUALMENTE.";
        } else {
          feedback.textContent =
            "REVISA Y CORRIGE LO QUE HAGA FALTA.";
        }

      } catch (error) {
        if (myGeneration !== generation) return;

        feedback.textContent = explainError(error);

      } finally {
        if (myGeneration === generation) {
          busy = false;
          generate.disabled = false;
          generate.textContent = "VOLVER A TRANSCRIBIR";
        }
      }
    }

    // ==========================================
    // CONFIRMAR
    // ==========================================

    confirm.addEventListener("click", () => {
      if (busy) {
        feedback.textContent =
          "ESPERA A QUE TERMINE LA TRANSCRIPCIÓN.";
        return;
      }

      const text = field.value.trim();

      if (!text) {
        feedback.textContent =
          "ESCRIBE O TRANSCRIBE TU RESPUESTA PRIMERO.";
        field.focus();
        return;
      }

      if (text.length > 4000) {
        feedback.textContent =
          "TU RESPUESTA ES DEMASIADO LARGA.";
        return;
      }

      confirmedText = text;

      panel.classList.add("uxs-confirmed");

      feedback.textContent =
        "TU SEÑAL TODAVÍA NO SE HA COMPARTIDO.";

      root.dispatchEvent(
        new CustomEvent(
          "uxs:transcription-confirmed",
          {
            bubbles: true,
            detail: {
              text,
              path: window.UXSSession?.path || null,
              question:
                window.UXSSession?.deepQuestion || null
            }
          }
        )
      );
    });

    // ==========================================
    // EVENTOS
    // ==========================================

    generate.addEventListener("click", transcribe);

    root.addEventListener(
      "uxs:audio-ready",
      () => {
        reset();

        // Inicio automático al estar lista
        // la grabación y VOICE 002.
        transcribe();
      }
    );

    root.addEventListener(
      "uxs:audio-cleared",
      reset
    );

    updateVisibility();

    // Para una página cargada con resultados.
    if (
      root.classList.contains("uxs-audio-ready") &&
      currentAudioSource()
    ) {
      transcribe();
    }

    console.log(
      "UXS Transcription V3 Ready"
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initialize
    );
  } else {
    initialize();
  }
})();
